const observer = new ResizeObserver( entries => {
	for( let entry of entries ) {
		const widget = entry.target;
		const tableScroller = widget.querySelector( '.table-scroller' );
		
		widget.classList[tableScroller.scrollWidth > tableScroller.clientWidth ? 'add' : 'remove']( 'overflow' );
	}
} );

document.querySelectorAll( '.whippet-comparison-table' ).forEach( widget => {
	const tableScroller = widget.querySelector( '.table-scroller' );

	if( tableScroller ) {
		observer.observe( widget );
	}
} );

document.querySelectorAll( '.whippet-comparison-table' ).forEach( widget => {
	const tableScroller = widget.querySelector( '.table-scroller' );
	
	if( tableScroller ) {
		// Add sentinel to the rightmost header column
		const sentinel = document.createElement( 'div' );
		sentinel.className = 'sentinel';
		widget.querySelector( 'table thead th:last-child' ).appendChild( sentinel );

		// Intersection observer
		new IntersectionObserver( entries => {
			for( let entry of entries ) {
				widget.classList[entry.isIntersecting ? 'add' : 'remove']( 'scrolled' );
			}
		}, {
			root: tableScroller,
			threshold: 1
		} ).observe( sentinel );
	}
} );

